import { TipTapEditor } from "./elements/tip-tap-editor.js";
import { AttachmentManager } from "./attachment-manager.js";

TipTapEditor.define();

export { TipTapEditor, AttachmentManager };
